import React, { Component } from 'react'
import actions from 'redux/actions'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import ModalWithActions from 'components/modal/ModalWithActions/ModalWithActions'

import messages from './messages'


// TODO seems it's a dialog modal (not 'with actions')
// TODO it isn't used?
export default class UnpauseRequiredModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
  }

  static defaultProps = {
    name: constants.modals.cancelSubscription.UnpauseRequired,
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  unpause = () => {
    this.close()

    actions.models.subscription.unpause({
      isCancellationFlow: true,
      placement: 'cancel subscription - unpause required popup',
    })
      .then(() => actions.models.modals.open(constants.modals.cancelSubscription.BeforeYouGo))
  }

  render() {
    const { name } = this.props

    const buttonProps = {
      brand: true,
      title: messages.button,
      onClick: this.unpause,
      key: 'buttonUnpause',
    }

    return (
      <ModalWithActions
        name={name}
        title={messages.title}
        actions={[ buttonProps ]}
      >
        <FormattedHTMLMessage tag="div" {...messages.text} />
      </ModalWithActions>
    )
  }
}
